import { Icon, TextField } from '@atom/mui';

const styles = {
  close: {
    cursor: 'pointer',
  },
};

export interface Props {
  query: string;
  setQuery: (query: string) => void;
  dataCyPrefix?: string;
}

const SearchInput = ({ query, setQuery, dataCyPrefix = '' }: Props) => (
  <TextField
    value={query}
    onChange={event => setQuery(event.target.value)}
    placeholder="Search"
    data-cy={`${dataCyPrefix}SearchInput`}
    slotProps={{
      input: {
        startAdornment: <Icon>search</Icon>,
        endAdornment: query && (
          <Icon style={styles.close} onClick={() => setQuery('')}>
            close
          </Icon>
        ),
      },
    }}
  />
);

export default SearchInput;
